import(/* webpackMode: "eager", webpackExports: ["Icon"] */ "/home/cwd/frontend_projects/cwd-website/node_modules/@iconify/react/dist/iconify.js");
;
import(/* webpackMode: "eager", webpackExports: ["SpeedInsights"] */ "/home/cwd/frontend_projects/cwd-website/node_modules/@vercel/speed-insights/dist/next/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/home/cwd/frontend_projects/cwd-website/node_modules/next-themes/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/cwd/frontend_projects/cwd-website/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/cwd/frontend_projects/cwd-website/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/cwd/frontend_projects/cwd-website/src/components/Layout/Header/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/cwd/frontend_projects/cwd-website/src/components/Products/Shared/SliderStyles.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/cwd/frontend_projects/cwd-website/src/components/ScrollToTop/index.tsx");
